module.exports = __webpack_public_path__ + "7f0993c06ad663e76ee3421c403d05cf.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/Stroke-Gap-Icons/Stroke-Gap-Icons.woff2
 ** module id = ./src/styles/fonts/Stroke-Gap-Icons/Stroke-Gap-Icons.woff2
 ** module chunks = 0
 **/